/* eslint-disable */

function soleConfiguredAvailableValue(product, optionIndex) {
  if (optionIndex < 0) return null;
  const available = [...new Set(
    product.variants
      .filter((variant) => variant.available)
      .map((variant) => variant.options[optionIndex])
  )];
  return available.length === 1 ? available[0] : null;
}

function selectedDropdownValue(selector) {
  const selected = selector.querySelector('.custom-select__option[aria-selected="true"]');
  if (selected && selected.dataset.value !== undefined) return selected.dataset.value || null;
  const native = selector.querySelector('select');
  return native && native.value ? native.value : null;
}

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form-main');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();
      this.variant = this.getSelectedVariant();
      this.selectedOptions = this.getSelectedOptions();
      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;

      this.addEventListener('change', this.handleVariantChange.bind(this));
      this.marketReady = false;
      this.initMarket().catch(()=>window.SwishMarketFailure(this,()=>this.initMarket()));

      // Defer these to allow for quick-add modal to full initialize
      setTimeout(() => {
        this.updateAvailability();
        this.updateAddToCartButton();
      });
    }

    async initMarket(){
      this.marketReady=false;this.dataset.marketReady='false';
      const api=await window.SwishMarketReady();
      await api.apply(this.data.product,false);
      const selectedMarketVariant = this.getSelectedVariant();
      let repairedInitialSelection = false;
      if (selectedMarketVariant && !selectedMarketVariant.available) {
        const replacement = this.data.product.variants.find((candidate) => candidate.available);
        if (replacement) {
          replacement.options.forEach((value, index) => this.selectConfiguredValue(index, value));
          repairedInitialSelection = true;
        }
      }
      const selectedFixedOption = this.selectSoleConfiguredOptions(api);
      this.marketReady=true;this.dataset.marketReady='true';
      this.variant=this.getSelectedVariant();
      if ((selectedFixedOption || repairedInitialSelection) && this.variant) this.updateVariantInput();
      api.order(this.data.product).forEach(i=>this.append(this.optionSelectors[i]));
      if(!this.marketUI)this.marketUI=api.mount(this,this.data.product,()=>this.selectedOptions);
      this.updateAvailability();this.updateMarketOptions();this.updateAddToCartButton();this.updatePrice();
    }

    selectConfiguredValue(optionIndex, value) {
      const selector = this.optionSelectors[optionIndex];
      if (selector.dataset.selectorType === 'dropdown') {
        const custom = selector.querySelector('custom-select');
        const option = [...selector.querySelectorAll('.custom-select__option[data-value]')]
          .find((candidate) => candidate.dataset.value === value);
        if (!custom || !option) return false;
        selector.querySelectorAll('.custom-select__option[aria-selected="true"]')
          .forEach((candidate) => candidate.setAttribute('aria-selected', 'false'));
        option.setAttribute('aria-selected', 'true');
        custom.selectedOption = option;
        custom.listbox?.setAttribute('aria-activedescendant', option.id);
        if (custom.button?.firstElementChild) custom.button.firstElementChild.textContent = option.firstElementChild.textContent;
        if (custom.nativeSelect) custom.nativeSelect.value = value;
      } else {
        const input = [...selector.querySelectorAll('input.js-option')].find((candidate) => candidate.value === value);
        if (!input) return false;
        input.checked = true;
      }
      this.selectedOptions[optionIndex] = value;
      return true;
    }

    selectSoleConfiguredOptions() {
      let changed = false;
      this.optionSelectors.forEach((selector, index) => {
        if (this.selectedOptions[index]) return;
        const value = soleConfiguredAvailableValue(this.data.product, index);
        if (value && this.selectConfiguredValue(index, value)) changed = true;
      });
      return changed;
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      if(!evt.target.closest('.option-selector'))return;
      this.selectedOptions = this.getSelectedOptions();
      const api=window.SwishMarketAvailability;
      const changed=Array.from(this.optionSelectors).findIndex(selector=>selector.contains(evt.target));
      if(api&&this.marketReady&&changed>=0){
        const cleared=api.repair(this.data.product,this.selectedOptions,changed);
        if(cleared){const selector=this.optionSelectors[api.sizeIndex(this.data.product)];selector.querySelectorAll('input:checked').forEach(input=>input.checked=false);const custom=selector.querySelector('custom-select');if(custom){const text=custom.querySelector('.custom-select__btn > span');if(text)text.textContent=this.dataset.placeholderText||theme.strings.noSelectedVariant;custom.querySelectorAll('[aria-selected=true]').forEach(el=>el.setAttribute('aria-selected','false'));let placeholder=custom.querySelector('[data-market-placeholder]');if(!placeholder){placeholder=document.createElement('li');placeholder.className='custom-select__option';placeholder.dataset.marketPlaceholder='';placeholder.dataset.value='';placeholder.id=custom.id+'-market-unselected';placeholder.setAttribute('role','option');const span=document.createElement('span');span.textContent=this.dataset.placeholderText||theme.strings.noSelectedVariant;placeholder.append(span);custom.listbox.prepend(placeholder);}placeholder.setAttribute('aria-selected','true');custom.selectedOption=placeholder;custom.listbox.setAttribute('aria-activedescendant',placeholder.id);if(custom.nativeSelect)custom.nativeSelect.selectedIndex=-1;}}
        this.marketUI?.selection(changed,this.selectedOptions[changed],cleared);
      }
      this.variant = this.getSelectedVariant();
      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;

      if (this.variant) {
        this.updateMedia();
        this.updateUrl(evt);
        this.updateVariantInput();
      } else if (api && changed === api.colorIndex(this.data.product)) {
        const preview = this.data.product.variants.find((candidate) =>
          candidate.available && candidate.options[changed] === this.selectedOptions[changed]
        );
        if (preview) this.updateMedia(preview);
      }

      this.updateAddToCartButton();
      this.updateAvailability();
      this.updateMarketOptions();
      this.updatePrice();
      this.updateWeight();
      this.updateBarcode();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateMetafieldVisibility();
      VariantPicker.updateLabelText(evt);

      if (!this.preSelection) {
        this.dispatchEvent(new CustomEvent('on:variant:change', {
          bubbles: true,
          detail: {
            form: this.productForm,
            variant: this.variant,
            product: this.data.product
          }
        }));
      }
    }

    /**
     * Shows/hides variant metafield elements on the page as necessary
     */
    updateMetafieldVisibility() {
      document.querySelectorAll('[data-variant-metafield]').forEach((elem) => {
        elem.classList.toggle('hidden', elem.dataset.variantMetafield !== this.variant?.id.toString());
      });
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector('.js-product-form-main');
      if (!this.productForm) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.marketReady && this.variant && this.variant.available;

      this.addBtn.disabled = !variantAvailable || this.preSelection;
      this.productForm.querySelectorAll('.shopify-payment-button').forEach(el=>el.hidden=!variantAvailable||this.preSelection);
      if(!variantAvailable)this.productForm.querySelectorAll('[name=id]').forEach(input=>input.value='');

      if (this.preSelection) {
        this.addBtn.textContent = theme.strings.noSelectedVariant;
      } else {

        const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
        this.addBtn.textContent = variantAvailable
          ? this.addBtn.dataset.addToCartText
          : unavailableStr;
      }
    }

    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    static updateOptionAvailability(optionEl, exists, available) {
      const el = optionEl;
      const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
      el.classList.toggle('is-unavailable', !available);
      el.classList.toggle('is-nonexistent', !exists);

      if (optionEl.classList.contains('custom-select__option')) {
        const em = el.querySelector('em');

        if (em) {
          em.hidden = available;
        }

        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        el.nextElementSibling.title = unavailableText;
      } else {
        el.nextElementSibling.removeAttribute('title');
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
      const { availabilityMethod } = this.dataset; // 'downward' or 'selection'
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.selectedOptions };
      }

      if (availabilityMethod === 'selection') {
        // Flag all options as unavailable
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          VariantPicker.updateOptionAvailability(optionEl, false, false);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.product.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                VariantPicker.updateOptionAvailability(optionEl, true, variant.available);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""])');
          options.forEach((option) => {
            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            // any available variants with previous options and this one locked in?
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.product.variants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === this.selectedOptions[i] || this.selectedOptions[i] === null) {
                  matches += 1;
                }
              }
              if (v.options[selectorIndex] === optionValue && matches === selectorIndex) {
                variantsExist = true;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable);
          });
        });
      }
    }

    updateMarketOptions() {
      this.optionSelectors.forEach((selector, index) => {
        selector.querySelectorAll('.js-option').forEach(option => {
          const value = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
          const api=window.SwishMarketAvailability;
          const color=api?.colorIndex(this.data.product), size=api?.sizeIndex(this.data.product);
          const permitted=this.marketReady && !(index===size&&color>=0&&!this.selectedOptions[color]) && api.optionAvailable(this.data.product,index,value,this.selectedOptions);
          option.disabled = !permitted;
          option.setAttribute('aria-disabled', String(!permitted));
          const visual = selector.dataset.selectorType === 'dropdown' ? option : option.nextElementSibling;
          if(visual){visual.style.setProperty('display', permitted ? '' : 'none', permitted ? '' : 'important');visual.dataset.preferredSize=String(index===size&&value===api?.preference()?.size);}
        });
      });
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default')
            ? ''
            : `. ${this.variant.title}`;

          if (backorderProdEl && prodTitleEl) {
            backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          }
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the product media.
     */
    updateMedia(variant = this.variant) {
      if (!variant?.featured_media) return;

      if (this.section.matches('quick-add-drawer')) {
        this.section.updateMedia(variant.featured_media.id);
      } else {
        this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-info__price > .price');
      if (!this.price) return;

      let { variant } = this;
      const showFrom=this.preSelection||!variant?.available;
      if(showFrom)variant=this.data.product.variants.filter(v=>v.available).sort((a,b)=>a.price-b.price)[0];

      if (variant) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');

        // Update price.
        if (variant.compare_at_price > variant.price) {
          priceCurrentEl.querySelector('.js-label').textContent = theme.strings.salePrice;
          priceCurrentEl.querySelector('.js-value').innerHTML = this.data.formatted[variant.id].price;
          if (priceWasEl) {
            priceWasEl.querySelector('.js-label').textContent = theme.strings.regularPrice;
            priceWasEl.querySelector('.js-value').innerHTML = this.data.formatted[variant.id].compareAtPrice || '';
          }
        } else {
          priceCurrentEl.querySelector('.js-label').textContent = theme.strings.regularPrice;
          priceCurrentEl.querySelector('.js-value').innerHTML = this.data.formatted[variant.id].price;
          if (priceWasEl) {
            priceWasEl.querySelector('.js-label').textContent = '';
            priceWasEl.querySelector('.js-value').innerHTML = '';
          }
        }

        // Update unit price, if specified.
        if (variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = variant.unit_price_measurement.reference_value;
          const unit = variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        unitPriceEl.hidden = !variant.unit_price_measurement;
        this.price.classList.toggle(
          'price--on-sale',
          variant.compare_at_price > variant.price
        );
        this.price.classList.toggle('price--sold-out', !variant.available && !this.preSelection);
      }

      this.price.querySelector('.price__default').hidden = !variant && !this.preSelection;
      this.price.querySelector('.price__no-variant').hidden = variant || this.preSelection;
      const from = this.price.querySelector('.price__from');
      if (from) {
        from.hidden = !showFrom;
      }
    }

    /**
     * Updates the weight.
     */
    updateWeight() {
      this.weights = this.weights || this.section.querySelectorAll('.product-info__weight');
      if (this.weights.length === 0) return;

      const weightAvailable = this.variant && this.variant.weight > 0;
      this.weights.forEach((weight) => {
        weight.textContent = weightAvailable ? this.data.formatted[this.variant.id].weight : '';
        weight.hidden = !weightAvailable;
      });
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcodes = this.barcodes || this.section.querySelectorAll('.product-info__barcode-value');
      if (this.barcodes.length === 0) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcodes.forEach((barcode) => {
        barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
        barcode.parentNode.hidden = !barcodeAvailable;
      });
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          selectedOptions.push(selectedDropdownValue(selector));
        } else {
          const selected = selector.querySelector('input:checked');
          selectedOptions.push(selected ? selected.value : null);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      const selectedOptions = this.getSelectedOptions();
      return this.data.product.variants.find(
        (v) => v.options.every((val, index) => val === selectedOptions[index])
      );
    }
  }

  customElements.define('variant-picker', VariantPicker);
}
